import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { RichLink } from '@root/src/web/components/RichLink';
import { DefaultRichLink } from '@root/src/web/components/DefaultRichLink';
import { useApi } from '@root/src/web/lib/useApi';
import { decideDisplay } from '@root/src/web/lib/decideDisplay';
import { decideDesign } from '@root/src/web/lib/decideDesign';
import { decideTheme } from '@root/src/web/lib/decideTheme';
const buildUrl = (element, ajaxUrl) => {
    const path = new URL(element.url).pathname;
    return `${ajaxUrl}/embed/card${path}.json?dcr=true`;
};
export const RichLinkComponent = ({ element, ajaxEndpoint, richLinkIndex, }) => {
    const url = buildUrl(element, ajaxEndpoint);
    const { data, error } = useApi(url);
    if (error) {
        // Send the error to Sentry
        window.guardian.modules.sentry.reportError(error, 'rich-link');
    }
    if (!data) {
        // Continue to return the default (server side rendered) version of the richlink
        return (_jsx(DefaultRichLink, { index: richLinkIndex, headlineText: element.text, url: element.url }, void 0));
    }
    const richLinkImageData = {
        thumbnailUrl: data.thumbnailUrl,
        altText: data.imageAsset?.fields.altText,
        width: data.imageAsset?.fields.width,
        height: data.imageAsset?.fields.height,
    };
    return (_jsx(RichLink, { richLinkIndex: richLinkIndex, cardStyle: data.cardStyle, imageData: richLinkImageData, headlineText: data.headline, contentType: data.contentType, url: data.url, starRating: data.starRating, format: {
            display: decideDisplay(data.format),
            design: decideDesign(data.format),
            theme: decideTheme(data.format),
        }, tags: data.tags, sponsorName: data.sponsorName, contributorImage: data.contributorImage }, void 0));
};
